import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { SE_PRIMACIAL, IMAGES } from "@/data/content";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export default function SePrimacial() {
  return (
    <section id="comunidades" data-testid="se-primacial-section" className="bg-[#2E070D] text-[#FBF9F4] px-4 sm:px-8 lg:px-16 py-20 lg:py-32">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={viewportOnce}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="relative"
        >
          <div className="absolute -top-4 -left-4 h-full w-full border border-[#C5A059]/40" />
          <img src={IMAGES.cathedral} alt="Nave de catedral — Sé Primacial da DACB em Esmeraldas/MG" loading="lazy" className="relative w-full aspect-[4/5] object-cover" />
          <div className="absolute bottom-6 left-6 bg-[#2E070D]/85 backdrop-blur-md border border-[#C5A059]/30 px-5 py-3">
            <p className="overline-label text-[#C5A059]">Sede da Diocese</p>
            <p className="font-display text-sm font-bold mt-1">Esmeraldas — Minas Gerais</p>
          </div>
        </motion.div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}>
          <motion.p variants={fadeUp} className="overline-label text-[#C5A059]">{SE_PRIMACIAL.categoria}</motion.p>
          <motion.h2 variants={fadeUp} className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold uppercase leading-tight">
            {SE_PRIMACIAL.nome}
          </motion.h2>
          <motion.div variants={fadeUp} className="gold-rule mt-8 w-40" />
          <motion.ul variants={fadeUp} className="mt-8 space-y-2">
            {SE_PRIMACIAL.endereco.map((line) => (
              <li key={line} className="flex items-center gap-3 text-[#FBF9F4]/75">
                <MapPin className="h-4 w-4 text-[#C5A059] shrink-0" />
                <span className="font-liturgy text-xl">{line}</span>
              </li>
            ))}
          </motion.ul>
          <motion.p variants={fadeUp} className="mt-8 max-w-lg text-sm leading-relaxed text-[#FBF9F4]/65">
            A Sé Primacial é a sede do governo diocesano, presidido pelo Arcebispo Primaz, e acolhe a paróquia
            formalmente constituída da DACB. Esmeraldas/MG é a sede da Sé — não o limite territorial da Diocese:
            a missão se estende por todo o Brasil por meio das Prelazias, missões, comunidades e pontos missionários.
          </motion.p>
          <motion.blockquote variants={fadeUp} className="mt-10 border-l-2 border-[#C5A059] pl-5">
            <p className="font-liturgy italic text-xl text-[#FBF9F4]/85">«Para que todos sejam um»</p>
            <cite className="overline-label text-[#C5A059] not-italic">Jo 17,21</cite>
          </motion.blockquote>
        </motion.div>
      </div>
    </section>
  );
}
